import { Component } from "@angular/core";

@Component({
	selector: "user-stats",
	templateUrl: "./user-stats.component.html",
})
export class UserStatsComponent {}
